import React, { useState } from "react";
import classes from "./style.module.scss";
import TableWrapper from "../../../../component/TableWrapper";
import { Icons } from "../../../../assets";
import NormalSelect from "../../../../component/NormalSelect";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import GetUserPermission from "../../../../component/GetUserPermission";

const NotificationTableList = (props) => {
  const {
    isLoading,
    setPage,
    userList,
    handleDelete,
    setCreateNotificationModal,
    sortConfig,
    setSortConfig
  } = props;

  const SENT = "Sent";
  const SCHEDULED = "Scheduled";
  const dropdownList = [
    { label: SENT, value: [SENT] },
    { label: SCHEDULED, value: [SCHEDULED] },
  ];

  const [selectedStatus, setSelectedStatus] = useState(SENT);
  const navigate = useNavigate();
  const deletePermission = GetUserPermission({ key: 'delete' });
  const editPermission = GetUserPermission({ key: 'edit' });

  const userHeader = [
    { label: "ID", sortable: "notification_id" },
    { label: "Title", sortable: "title" },
    { label: "Message" },
    { label: "Type" },
    { label: "Status" },
    { label: "Actions" },
  ];

  const handleChange = (value) => {
    setSelectedStatus(Array.isArray(value) ? value?.at(0) : value);
  };

  const handleData = (keyValue, defaultValue, className = "") => {
    return (
      <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
    );
  };

  const handleMessage = (keyValue, defaultValue, className = "", charLimit = 25) => {
    const truncateChars = (text, limit) => {
      return text?.length > limit ? text.slice(0, limit) + "..." : text;
    };
  
    return (
      <td className={`${className}`}>
        {keyValue ? truncateChars(keyValue, charLimit) : defaultValue}
      </td>
    );
  };

  const redirectTo = (notification_id) => {
    navigate(`?id=${notification_id}`);
  };

  return (
    <>
      <div className={`eventWrapper`}>
        <div className={`mt-2 mb-5 ${classes.adminTableWrapper}`}>
          <TableWrapper
            headerDetails={userHeader}
            pageMeta={userList?.pageMeta}
            handlePageChange={setPage}
            listLength={userList?.result || []}
            isLoading={isLoading}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
          >
            {userList?.result?.map((item, index) => {
              const {
                notification_id = "",
                title = "",
                message = "",
                type = "",
                status = "",
              } = item;
              return (
                <tr key={notification_id}>
                  {handleData(notification_id, "-", "text-center")}
                  {handleData(title, "-", "text-center")}
                  {handleMessage(message, "-", "text-center")}
                  {handleData(
                    type === 1
                      ? "GENERAL"
                      : type === 2
                        ? "PROMOTIONAL"
                        : "ALERT",
                    "-",
                    "text-center"
                  )}
                  <td className=" px-3 mx-auto text-center w-[130px]">
                    <div className='' style={{
                      color: status === 2 ? '#FC0000' :
                        status === 1 ?  '#01CB46' : '#000000'
                    }}>
                      {status === 1 ? 'Sent' :
                        status === 2 ? 'Scheduled' : ""}
                    </div>
                  </td>
                  <td className=" px-3 mx-auto text-center action-button">
                    <div className="flex items-center justify-center gap-2">
                      <img
                        src={Icons.eye}
                        alt="View"
                        className="cursor-pointer w-[20px] h-[20px]"
                        onClick={() => redirectTo(notification_id)}
                      />
                      {/* {editPermission &&
                        <img
                          src={Icons.edit}
                          alt="Edit"
                          className="cursor-pointer w-[18px] h-[18px] mx-2"
                        />
                      } */}
                      {deletePermission &&
                        <img
                          src={Icons.delete}
                          alt="Delete"
                          className="cursor-pointer w-[20px] h-[20px]"
                          onClick={() => handleDelete(notification_id)}
                        />
                      }
                    </div>
                  </td>
                </tr>
              );
            })}
          </TableWrapper>
        </div>
      </div>
    </>
  );
};

export default NotificationTableList;
